module.exports = __webpack_public_path__ + "img/group1Img.94fca06c.png";